var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { isMutation, getActionType, } from '@loona/core';
import { LoonaContext } from '../context';
var Action = /** @class */ (function (_super) {
    __extends(Action, _super);
    function Action() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Action.prototype.createDispatch = function (loona) {
        var _this = this;
        return function (actionOrPayload) {
            if (!loona) {
                throw new Error('No Loona no fun!');
            }
            var action;
            if (isMutation(actionOrPayload)) {
                action = actionOrPayload;
            }
            else {
                action = _this.props.action
                    ? __assign({ type: _this.props.action }, actionOrPayload) : __assign({ type: getActionType(actionOrPayload) }, actionOrPayload);
            }
            loona.dispatch(action);
        };
    };
    Action.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        return (React.createElement(LoonaContext.Consumer, null, function (_a) {
            var loona = _a.loona;
            return children(_this.createDispatch(loona));
        }));
    };
    Action.propTypes = {
        action: PropTypes.any,
        children: PropTypes.func.isRequired,
    };
    return Action;
}(React.Component));
export { Action };
//# sourceMappingURL=action.js.map